<template>
  <div>
    <a-col :sm="24" :md="12" :xl="12">
      <a-card :title="getGreetingTime">
        <h2>Transactions summary for
          <strong v-if="items.month !== 0 && items.year !== 0">{{ moment({ month: items.month - 1 , year: items.year }).format("MMMM YYYY") }}</strong>
          <strong v-else>{{ moment().format("MMMM YYYY") }}</strong>
        </h2>
      </a-card>
    </a-col>
    <a-col :sm="24" :md="12" :xl="6">
      <a-card>
        <a-statistic
          title="Transactions Amount"
          :value="items.client_price"
          prefix="Rp"
          :value-style="{ color: '#4b4dc1' }"
          style="margin-right: 50px">
          <template #prefix>
            <a-icon type="arrow-up" />
          </template>
        </a-statistic>
      </a-card>
    </a-col>
    <a-col :sm="24" :md="12" :xl="6">
      <a-card>
        <a-statistic
          title="Biller's Charge Amount"
          :value="items.biller_price"
          prefix="Rp"
          :value-style="{ color: '#ba8c4e' }"
          style="margin-right: 50px">
          <template #prefix>
            <a-icon type="arrow-up" />
          </template>
        </a-statistic>
      </a-card>
    </a-col>
    <a-col :sm="24" :md="12" :xl="6">
      <a-card>
        <a-statistic
          title="Count"
          :value="items.count"
          :value-style="{ color: '#3468c2' }"
          style="margin-right: 50px">
          <template #suffix>
            <a-icon type="arrow-up" />
          </template>
        </a-statistic>
      </a-card>
    </a-col>
    <a-col :sm="24" :md="12" :xl="6">
      <a-card>
        <a-statistic
          title="Profit"
          :value="items.profit"
          prefix="Rp"
          :value-style="{ color: '#3f8600' }">
          <template #suffix>
            <a-icon type="stock" />
          </template>
        </a-statistic>
      </a-card>
    </a-col>
  </div>
</template>

<script>
import moment from 'moment';

const getGreetingTime = () => {
  const splitMorning = 6
  const splitAfternoon = 12
  const splitEvening = 17
  const splitNight = 20

  const currentHour = parseFloat(moment().format('HH'))

  if (currentHour >= splitMorning && currentHour <= splitAfternoon) {
    return 'Good morning!'
  } else if (currentHour >= splitAfternoon && currentHour <= splitEvening) {
    return 'Good afternoon!'
  } else if (currentHour >= splitEvening && currentHour <= splitNight) {
    return 'Good evening!'
  }
  return 'Good night!'
}

export default {
  name: "summary-statistics",
  props: {
    uri: {
      type: String,
      default: null
    }
  },
  mounted() {
    this.getItems()
  },
  data: () => ({
    getGreetingTime,
    loading: false,
    items: {
      count: 0,
      price: 0,
      biller_price: 0,
      profit: 0,
      month: 0
    }
  }),
  methods: {
    getItems() {
      this.loading = true
      this.$http.get(this.uri !== null ? this.uri : this.routeUri('hyperion.transaction.summary'))
        .then(res => {
          if (res.data.length !== 0) {
            this.items = res.data[0]
          }
        }).catch(err => this.handleXhrError(err))
        .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

</style>
